export default __webpack_public_path__ + "img/436fb1c82326ec0f4ec878c594276531.svg";